import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { isTouchEnabled } from '../Theme';
import useWidth from './Hooks/useWidth';
import Tooltip from './Tooltip';

const ErrorTooltip = ({ errorMessage }: { errorMessage: string }) => {
  const [showTooltipError, setShowTooltipError] = useState(false);
  const { mobileWidth } = useWidth();

  if (isTouchEnabled) {
    return (
      <Tooltip
        open={showTooltipError}
        onOpen={() => setShowTooltipError(true)}
        onClose={() => setShowTooltipError(false)}
        arrow
        title={errorMessage}
        backgroundColor="error"
      >
        <IconButton
          size={mobileWidth ? 'small' : 'medium'}
          onClick={() => setShowTooltipError(!showTooltipError)}
        >
          <ErrorRoundedIcon color="error" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip arrow title={errorMessage} backgroundColor="error">
      <ErrorRoundedIcon color="error" />
    </Tooltip>
  );
};

export default ErrorTooltip;
